let tb_Categoria = {
  1: "Mensalista",
  5: "Horista",
  // ?: semanalista
  // ?: diarista
  // ?: tarefeiro
  // ?: comissionado
}
// CONFERIR TODAS AS OPÇÕES QUE APARECEM... COLOCAR ? CASO NÃO ESTEJA NA RELAÇÃO ACIMA

let tb_Vinculo = {
  1: 'Celetista',
  5: 'Celetista Contrato Prazo Determinado',
  50: '?',
  53: 'Aprendiz',
}
// vinculo empregaticio
// CONFERIR TODAS AS OPÇÕES QUE APARECEM... COLOCAR ? CASO NÃO ESTEJA NA RELAÇÃO ACIMA

let tb_TipoEndereco = {
  2: 'Alameda',
  4: 'Avenida',
  13: 'Estrada',
  15: 'Fazenda',
  18: 'Ladeira',
  33: 'Rua',
  36: 'Travessa',
  39: 'Vale',
  44: 'Vila',
  162: 'Servidão',
}

let tb_EstadoCivil = {
  'C' : 'Casado(a)',
  'D' : 'Divorciado(a)',
  'O' : 'Concubinato(a)',
  'S' : 'Solteiro(a)',
  'V' : 'Viúvo(a)',
}

let tb_Sexo = {
  'M' : 'Masculino',
  'F' : 'Feminino',
}

let tb_GrauInstrucao = {
  2: 'Ensino Fundamental até 5o Incompleto',
  3: 'Ensino Fundamental 5o Completo',
  4: 'Ensino Fundamental 6o ao 9o',
  5: 'Ensino Fundamental Completo',
  6: 'Ensino Médio Incompleto',
  7: 'Ensino Médio Completo',
  8: 'Superior Incompleto',
  9: 'Superior Completo',
  //---
  1: 'Analfabeto',
  10: 'Pós-Graduação',
  11: 'Mestrado',
  12: 'Doutorado',
  13: 'PhD',
}


export {
  tb_Categoria,
  tb_Vinculo,
  tb_TipoEndereco,
  tb_EstadoCivil,
  tb_Sexo,
  tb_GrauInstrucao,
}
